import React from 'react';
import {useTune} from './state.jsx';
export function WaveBars(){return <span className="playing-waves" aria-hidden="true">{[0,1,2,3].map(i=><i key={i} style={{'--wave-index':i}}/>)}</span>;}
export default function PlayingIndicator({station}){
  const {current,playbackStatus}=useTune();
  if(!station?.stationuuid||current?.stationuuid!==station.stationuuid||playbackStatus!=='playing')return null;
  return <span className="playing-indicator" role="status" aria-label={`Now playing ${station.name}`}><WaveBars/><span className="text-[9px] font-semibold">Playing</span></span>;
}
